const useCopyToClipboard = () => {
  const copyToClipboard = (text: string) =>
    navigator.clipboard
      .writeText(text)
      .then(() => ({ success: true, message: `Copied to the clipboard` }))
      .catch(() => {
        const input = document.createElement('input');
        input.value = text;

        document.body.appendChild(input);

        input.focus();
        input.select();

        const success = document.execCommand('copy');
        document.body.removeChild(input);

        return {
          success,
          message: success
            ? `Copied to the clipboard`
            : `Failed to copy to the clipboard`,
        };
      });

  return copyToClipboard;
};

export default useCopyToClipboard;
